module.exports = __webpack_public_path__ + "img/pic2.39e317fa.jpg";